import { useContext, useEffect, useState } from "react";
import Layout from "../../shared/Layout";
import HeroPage from "./components/HeroPage/HeroPage";
import "./Home.scss";
// import { useTranslation } from 'react-i18next'
import { AuthContext } from "../../context/AuthProvider";
import Catalog from "./components/Catalog/Catalog";
import { courseService } from "../../services/course.service";
import { Category } from "../../types";
import { useMediaQuery } from "@mui/material";
// import Events from './components/Events/Events'
// import Reviews from './components/Reviews/Reviews'
// import Form from './components/Form/Form'

const Home = () => {
  // const { t } = useTranslation()
  const { authenticated } = useContext(AuthContext);
  const [recommendations, setRecommendations] = useState([]);
  const [popular, setPopular] = useState([]);
  const [popularNumber, setPopularNumber] = useState(0);
  const [popularPage, setPopularPage] = useState(0);
  const [recommendationNumber, setRecommendationNumber] = useState(0);
  const [recommendationPage, setRecommendationPage] = useState(0);
  const [category, setCategory] = useState<Category[]>([]);
  const [categoryLoad, setCategoryLoad] = useState(true);

  const isMobile = useMediaQuery("(max-width:1000px)");
  const limit = isMobile ? 1 : 4;

  useEffect(() => {
    courseService
      .getCoursesList(
        `group_by=MOST_POPULAR&limit=${limit}&page=${popularPage}`
      )
      .then((data) => {
        setPopular(data?.data?.items || []);
        setPopularNumber(data?.data?.total || 0);
      });
  }, [authenticated, popularPage, limit]);

  useEffect(() => {
    if (authenticated) {
      courseService
        .getRecommendationCourses(`page=${recommendationPage}&limit=${limit}`)
        .then((data) => {
          setRecommendations(data?.data?.items || []);
          setRecommendationNumber(data?.data?.total || 0);
        });
    }
  }, [recommendationPage, authenticated, limit]);

  useEffect(() => {
    courseService.getCourseCategory().then((data) => {
      setCategory(data);
      setCategoryLoad(false);
    });
  }, []);

  return (
    <>
      {/*<div className={'home-header'}>
			<span className={'home-link first'}>{t('О нас')}</span>
			<span className={'home-link'}>{t('Стать преподавателем')}</span>
		</div>*/}
      <Layout fullWidth>
        <HeroPage
          category={category}
          categoryLoad={categoryLoad}
          popular={popular}
          popularNumber={popularNumber}
          setPopularPage={setPopularPage}
          popularPage={popularPage}
          recommendations={recommendations}
          recommendationNumber={recommendationNumber}
          setRecommendationPage={setRecommendationPage}
          recommendationPage={recommendationPage}
          authenticated={authenticated}
        />
        <Catalog
          card={popular}
          title={"Популярное"}
          total={popularNumber}
          setPage={setPopularPage}
          page={popularPage}
          isHome
        />
        {authenticated ? (
          <>
            <Catalog
              card={recommendations}
              title={"Рекомендовано для вас"}
              total={recommendationNumber}
              setPage={setRecommendationPage}
              page={recommendationPage}
              isHome
            />
          </>
        ) : null}
        {/*<Events />*/}
        {/*<Reviews />*/}
        {/*<Form />*/}
      </Layout>
    </>
  );
};

export default Home;
